import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { defaultIfEmpty, map, mergeMap, take } from 'rxjs/operators';
import { PaymentSummaryStore } from './payment-summary.store';
import { EventStore } from '../event.store';
import { OnyxEvent } from 'app/event/models/event';

@Injectable()
export class PaymentSummaryResolver implements Resolve<void> {

  constructor(
    private paymentSummaryStore: PaymentSummaryStore,
    private eventStore: EventStore,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<void> {
    return this.extractEventPartyIds().pipe(
      mergeMap((eventPartyIdSet: Set<number>) => this.paymentSummaryStore.resolveCache(eventPartyIdSet)),
    );
  }

  private extractEventPartyIds(): Observable<Set<number>> {
    return this.eventStore.selectedEvent.pipe(
      take(1),
      defaultIfEmpty(null),
      map((event: OnyxEvent) => {
        if (!event) {
          throw new Error('Could not obtain selected event');
        }

        const eventPartyIds: number[] = [];

        if (event.eventProperty) {
          eventPartyIds.push(event.eventProperty.eventPartyId);
        }

        if (event.eventVendors) {
          event.eventVendors.forEach(v => eventPartyIds.push(v.eventPartyId));
        }

        const uniqueValidIds = new Set(eventPartyIds.filter(id => !!id));

        if (uniqueValidIds.size === 0) {
          throw new Error('Could not identify vendors');
        }

        return uniqueValidIds;
      })
    );
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/payment-summary/payment-summary.resolver.ts